export default [
    'Local',
    'Offshore',
    'Landed'
]
export const assignmentSitesEnums = Object.freeze(({'Local': 0, 'Offshore': 1, 'Landed': 2}));